module.exports = "div.button-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-pack: space-evenly;\n      -ms-flex-pack: space-evenly;\n          justify-content: space-evenly;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/approval-modal/approval-modal.component.scss
// module id = ./src/app/common/approval-modal/approval-modal.component.scss
// module chunks = main